import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { unselectAll } from "../../actions/multiselectActions";
import { setDocumentListShowTrash } from "../../actions/browserLocalstorageActions";

import {
	encodeFullpath,
	decodeFullpath,
	iconMap,
} from "../../utilities/utilities";

import MaterialTabs from "../MaterialTabs";

import TrashBinList from "./TrashBinList";
import {
	getPermanentDeleteJobDetails,
	listTrash,
} from "../../actions/trashActions";
import InteractiveTableCell, {
	ActionsTableCell,
} from "../Tables/InteractiveTableCell";
import {
	generatePermanentDeleteManifestForDocuments,
	generatePermanentDeleteManifestForEmails,
	generatePermanentDeleteManifestForFolders,
	generatePermanentDeleteManifestForNotes,
	generatePermanentDeleteManifestForMatters,
	restoreFromTrashPageDocuments,
	restoreFromTrashPageEmails,
	restoreFromTrashPageFolders,
	restoreFromTrashPageNotes,
	generatePermanentDeleteManifestForClients,
} from "../../actions/documentActions";
import { setClientLifecycleStatus } from "../../actions/clientActions";
import { NORMAL_LIFECYCLE_STATUS } from "../../utilities/lifecycleStatus";
import { deleteRestoreMultipleMattersFromTrashPage } from "../../actions/matterActions";
import CustomizableTable from "../Tables/CustomizableTable";
import { DropDownButton } from "../DropDownButton";
import { LexWorkplaceGavelIcon } from "../LexWorkplaceIcons";
import { IconInfoCircle } from "@tabler/icons-react";
import { ID_COLUMN_WIDTH } from "../Tables/SortableTable";

const basepathnameMap = {
	docs: "Documents",
	email: "Email",
	notes: "Notes",
	matters: "Matters",
	clients: "Clients",
	activity: "Activity",
};
const tabMap = [
	{ label: "Clients", url: "clients" },
	{ label: "Matters", url: "matters" },
	{ label: "Documents", url: "docs" },
	{ label: "Email", url: "email" },
	{ label: "Notes", url: "notes" },
	{ label: "Activity", url: "activity" },
];

const defaultColumnConfig = [
	{
		Header: "Name",
		accessor: "name",
		Cell: (cellInfo) => {
			return (
				<div className="documentListCell">
					<div className="documentListCellText">{cellInfo.value}</div>
				</div>
			);
		},
		filterMethod: (filter, row) => {
			return row[filter.id]
				.toString()
				.toLowerCase()
				.includes(filter.value.toString().toLowerCase());
		},
		filterAll: true,

		minWidth: 200,
		maxWidth: 400,
		sortable: true,
		resizable: true,
		className: "documentListCell",
		headerClassName: "documentListHeader",
		headerStyle: {
			textAlign: "left",
			fontWeight: "bold",
			fontSize: "14px",
		},
	},
];

const IdCell = (row) => {
	//note that under this implementation the folder is still filterable
	//via the ID filter text field.  Makes the results a bit confusing perhaps, but useful
	//if you are looking for a folder by ID
	return (
		<div style={{ textAlign: "left" }} data-id={row.value}>
			{row.original.type === "Folder" ? "" : row.value}
		</div>
	);
};

const NameCell = (props) => {
	const { icon, iconComponent, color } = iconMap(props.row);
	return InteractiveTableCell({
		...props,
		icon,
		iconColor: color,
		iconComponent,
	});
};

const tabUrlMap = {
	"clients/": {
		index: 0,
		customColumnsKey: "/trash/clients",
		breadcrumbsIcon: "user",
		selectionListName: "selectedTrashClients",
		backendRoot: "/trash/clients",
		itemNoun: "clients",
		csvFileName: "clients-in-trash",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/clients",
		noResultsText: "No Clients in the Trash Bin",
	},
	"matters/": {
		index: 1,
		customColumnsKey: "/trash/matters",
		breadcrumbsIcon: "briefcase",
		selectionListName: "selectedTrashMatters",
		backendRoot: "/trash/matters",
		itemNoun: "matters",
		csvFileName: "matters-in-trash",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/matters",
		noResultsText: "No Matters in the Trash Bin",
	},
	"docs/": {
		index: 2,
		customColumnsKey: "/trash/documents",
		breadcrumbsIcon: "file",
		selectionListName: "selectedTrashDocuments",
		backendRoot: "/trash/document",
		itemNoun: "documents",
		csvFileName: "documents-in-trash",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/docs",
		noResultsText: "No Documents or Folders in the Trash Bin",
	},
	"email/": {
		index: 3,
		customColumnsKey: "/trash/email",
		breadcrumbsIcon: "envelope",
		selectionListName: "selectedTrashEmails",
		backendRoot: "/trash/email",
		itemNoun: "emails",
		csvFileName: "emails-in-trash",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/email",
		noResultsText: "No Emails or Folders in the Trash Bin",
	},
	"notes/": {
		index: 4,
		customColumnsKey: "/trash/notes",
		breadcrumbsIcon: "pencil-alt",
		selectionListName: "selectedTrashNotes",
		backendRoot: "/trash/notes",
		itemNoun: "notes",
		csvFileName: "notes-in-trash",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/notes",
		noResultsText: "No Notes or Folders in the Trash Bin",
	},
	"activity/": {
		index: 5,
		customColumnsKey: "/trash/activity",
		breadcrumbsIcon: "",
		selectionListName: "selectedTrashJobs",
		backendRoot: "/trash/activity",
		itemNoun: "activity",
		csvFileName: "trash-activity",
		columns: defaultColumnConfig,
		tableUniqueId: "/trash/activity",
		noResultsText: "No Activities have been run",
	},
};

class TrashBinContainer extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			s3Basepath: "",
			matterInfoHidden: false,
			lastLocation: {
				docs: "docs/",
				email: "email/",
				notes: "notes/",
				matters: "matters/",
				clients: "clients/",
				activity: "activity/",
			},
		};
		this.switchedTab = this.switchedTab.bind(this);
		this.getUrlPrefix = this.getUrlPrefix.bind(this);
		this.getAPIBasepath = this.getAPIBasepath.bind(this);

		this.nameCell = this.nameCell.bind(this);

		this.actionsCell = this.actionsCell.bind(this);

		this.docsColumnConfig = [
			{
				Header: "ID",
				accessor: "id",
				width: ID_COLUMN_WIDTH,
				Cell: IdCell,
			},
			{
				Header: "Name",
				accessor: "filename",
				width: 200,
				Cell: (row) => {
					return <div>{this.nameCell(row)}</div>;
				},
				wildcard: true,
				unhidable: true,
			},
			{
				Header: "Matter",
				accessor: "matterName",
				width: 250,
			},
			{
				Header: "Client",
				accessor: "clientName",
				width: 250,
			},
			{
				Header: "Location",
				accessor: "displayFolderPath",
				width: 250,
				Cell: (row) => {
					return (
						<Link
							to={row.original.folderPath}
							onClick={() => {
								if (!this.props.documentListShowTrash) {
									this.props.setDocumentListShowTrash(true);
								}
							}}
						>
							{row.value}
						</Link>
					);
				},
			},
			{
				Header: "",
				accessor: "actions",
				width: 80,
				sortable: false,
				filterable: false,
				Cell: (row) => this.actionsCell(row),
			},
		];
		this.emailColumnConfig = [
			{
				Header: "ID",
				accessor: "id",
				width: ID_COLUMN_WIDTH,
				Cell: IdCell,
			},
			{
				Header: "Subject",
				accessor: "filename",
				width: 200,
				Cell: (row) => {
					return <div>{this.nameCell(row)}</div>;
				},
				wildcard: true,
				unhidable: true,
			},
			{
				Header: "Matter",
				accessor: "matterName",
				width: 250,
			},
			{
				Header: "Client",
				accessor: "clientName",
				width: 250,
			},
			{
				Header: "Location",
				accessor: "displayFolderPath",
				width: 250,
				Cell: (row) => {
					return (
						<Link
							to={row.original.folderPath}
							onClick={() => {
								if (!this.props.documentListShowTrash) {
									this.props.setDocumentListShowTrash(true);
								}
							}}
						>
							{row.value}
						</Link>
					);
				},
			},
			{
				Header: "",
				accessor: "actions",
				width: 80,
				sortable: false,
				filterable: false,
				Cell: (row) => this.actionsCell(row),
			},
		];
		this.notesColumnConfig = [
			{
				Header: "ID",
				accessor: "id",
				width: ID_COLUMN_WIDTH,
				Cell: IdCell,
			},
			{
				Header: "Name",
				accessor: "filename",
				width: 200,
				Cell: (row) => {
					return <div>{this.nameCell(row)}</div>;
				},
				wildcard: true,
				unhidable: true,
			},
			{
				Header: "Matter",
				accessor: "matterName",
				width: 250,
			},
			{
				Header: "Client",
				accessor: "clientName",
				width: 250,
			},
			{
				Header: "Location",
				accessor: "displayFolderPath",
				width: 250,
				Cell: (row) => {
					return (
						<Link
							to={row.original.folderPath}
							onClick={() => {
								if (!this.props.documentListShowTrash) {
									this.props.setDocumentListShowTrash(true);
								}
							}}
						>
							{row.value}
						</Link>
					);
				},
			},
			{
				Header: "",
				accessor: "actions",
				width: 80,
				sortable: false,
				filterable: false,
				Cell: (row) => this.actionsCell(row),
			},
		];
		this.mattersColumnConfig = [
			{
				Header: "ID",
				accessor: "id",
				width: ID_COLUMN_WIDTH,
				Cell: IdCell,
			},
			{
				Header: "Matter",
				accessor: "matterName",
				width: 200,
				Cell: (row) => {
					return (
						<InteractiveTableCell
							menuItems={this.getMenuItems(row)}
						>
							<Link to={"/matters/" + row.original.id + "/docs/"}>
								{row.value}
							</Link>
						</InteractiveTableCell>
					);
				},
				wildcard: true,
				unhidable: true,
			},
			{
				Header: "Client",
				accessor: "clientName",
				width: 250,
			},
			{
				Header: "",
				accessor: "actions",
				width: 80,
				sortable: false,
				filterable: false,
				Cell: (row) => this.actionsCell(row),
			},
		];
		this.clientsColumnConfig = [
			{
				Header: "ID",
				accessor: "id",
				width: ID_COLUMN_WIDTH,
				Cell: IdCell,
			},
			{
				Header: "Client",
				accessor: "clientName",
				width: 200,
				Cell: (row) => {
					return (
						<InteractiveTableCell
							menuItems={this.getMenuItems(row)}
						>
							<Link to={"/clients/" + row.original.id}>
								{row.value}
							</Link>
						</InteractiveTableCell>
					);
				},
				wildcard: true,
				unhidable: true,
			},
			{
				Header: "",
				accessor: "actions",
				width: 80,
				sortable: false,
				filterable: false,
				Cell: (row) => this.actionsCell(row),
			},
		];
		this.jobsColumnConfig = [
			{
				Header: "Status",
				accessor: "status",
				width: 150,
				Cell: (row) => {
					return <div>{row.value}</div>;
				},
			},
			{
				Header: "Performed By",
				accessor: "userPerformingOperationDisplayName",
				width: 150,
			},
			{
				Header: "Started",
				accessor: "startTime",
				width: 200,
				Cell: (row) => {
					return (
						<div>
							{row.value
								? new Date(row.value).toLocaleString()
								: ""}
						</div>
					);
				},
			},
			{
				Header: "Completed",
				accessor: "endTime",
				width: 200,
				Cell: (row) => {
					return (
						<div>
							{row.value
								? new Date(row.value).toLocaleString()
								: ""}
						</div>
					);
				},
			},
			{
				Header: "Details",
				accessor: "actions",
				width: 150,
				sortable: false,
				filterable: false,
				Cell: (row) => {
					return (
						<div
							className="lw-internal-action-link blue"
							onClick={() => {
								this.props.getPermanentDeleteJobDetails(
									row.original.id
								);
							}}
						>
							View Details
						</div>
					);
				},
			},
		];
		tabUrlMap["activity/"].columns = this.jobsColumnConfig;

		tabUrlMap["docs/"].columns = this.docsColumnConfig;
		tabUrlMap["email/"].columns = this.emailColumnConfig;
		tabUrlMap["notes/"].columns = this.notesColumnConfig;
		tabUrlMap["matters/"].columns = this.mattersColumnConfig;
		tabUrlMap["clients/"].columns = this.clientsColumnConfig;
	}

	getMenuItems(row) {
		let menuItems = [];
		if (row.original.type === "File") {
			menuItems.push({
				text: "Restore Document",
				onSelect: () => {
					this.props.restoreFromTrashPageDocuments.call(null, [
						row.original.id,
					]);
				},
			});
			menuItems.push({
				text: "Permanently Delete Document",
				onSelect: () =>
					this.props.generatePermanentDeleteManifestForDocuments.call(
						null,
						[row.original.id]
					),
			});
		}
		if (row.original.type === "Email") {
			menuItems.push({
				text: "Restore Email",
				onSelect: () => {
					this.props.restoreFromTrashPageEmails.call(null, [
						row.original.id,
					]);
				},
			});
			menuItems.push({
				text: "Permanently Delete Email",
				onSelect: () =>
					this.props.generatePermanentDeleteManifestForEmails.call(
						null,
						[row.original.id]
					),
			});
		}

		if (row.original.type === "Note") {
			menuItems.push({
				text: "Restore Note",
				onSelect: () => {
					this.props.restoreFromTrashPageNotes.call(null, [
						row.original.id,
					]);
				},
			});
			menuItems.push({
				text: "Permanently Delete Note",
				onSelect: () =>
					this.props.generatePermanentDeleteManifestForNotes.call(
						null,
						[row.original.id]
					),
			});
		}
		if (row.original.type === "Folder") {
			menuItems.push({
				text: "Restore Folder",
				onSelect: () => {
					this.props.restoreFromTrashPageFolders.call(null, [
						row.original.id,
					]);
				},
			});
			menuItems.push({
				text: "Permanently Delete Folder",
				onSelect: () =>
					this.props.generatePermanentDeleteManifestForFolders.call(
						null,
						[row.original.id]
					),
			});
		}
		if (row.original.type === "Matter") {
			menuItems.push({
				text: "Restore Matter",
				onSelect: () => {
					this.props.deleteRestoreMultipleMattersFromTrashPage({
						matterIDs: [row.original.id],
						isDeleted: 0,
					});
				},
			});
			menuItems.push({
				text: "Permanently Delete Matter",
				onSelect: () => {
					this.props.generatePermanentDeleteManifestForMatters.call(
						null,
						[row.original.id]
					);
				},
			});
		}
		if (row.original.type === "Client") {
			menuItems.push({
				text: "Restore Client",
				onSelect: () => {
					this.props.setClientLifecycleStatus({
						clientIDs: [row.original.id],
						lifecycleStatus: NORMAL_LIFECYCLE_STATUS,
						location: "trashBin",
					});
				},
			});
			menuItems.push({
				text: "Permanently Delete Client",
				onSelect: () =>
					this.props.generatePermanentDeleteManifestForClients.call(
						null,
						[row.original.id]
					),
			});
		}

		return menuItems;
	}

	getActionIconFunctions(row) {
		let actions = {};
		if (row.original.type === "File") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.restoreFromTrashPageDocuments.call(null, [
					row.original.id,
				]);
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForDocuments.call(
					null,
					[row.original.id]
				);
		}
		if (row.original.type === "Email") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.restoreFromTrashPageEmails.call(null, [
					row.original.id,
				]);
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForEmails.call(null, [
					row.original.id,
				]);
		}

		if (row.original.type === "Note") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.restoreFromTrashPageNotes.call(null, [
					row.original.id,
				]);
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForNotes.call(null, [
					row.original.id,
				]);
		}
		if (row.original.type === "Folder") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.restoreFromTrashPageFolders.call(null, [
					row.original.id,
				]);
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForFolders.call(
					null,
					[row.original.id]
				);
		}
		if (row.original.type === "Matter") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.deleteRestoreMultipleMattersFromTrashPage({
					matterIDs: [row.original.id],
					isDeleted: 0,
				});
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForMatters.call(
					null,
					[row.original.id]
				);
		}
		if (row.original.type === "Client") {
			actions.restoreFromTrashClickHandler = () => {
				this.props.setClientLifecycleStatus({
					clientIDs: [row.original.id],
					lifecycleStatus: NORMAL_LIFECYCLE_STATUS,
					location: "trashBin",
				});
			};
			actions.permanentDeleteClickHandler = () =>
				this.props.generatePermanentDeleteManifestForClients.call(
					null,
					[row.original.id]
				);
		}

		return actions;
	}

	nameCell(row) {
		const menuItems = this.getMenuItems(row);
		return (
			<NameCell menuItems={menuItems} row={row}>
				<span title={row.value}>{row.value}</span>
			</NameCell>
		);
	}

	actionsCell(row) {
		const { restoreFromTrashClickHandler, permanentDeleteClickHandler } =
			this.getActionIconFunctions(row);
		return (
			<ActionsTableCell
				row={row}
				numColumns={2}
				showPermanentDelete
				permanentDeleteClickHandler={permanentDeleteClickHandler}
				showRestoreFromTrashPage
				restoreFromTrashClickHandler={restoreFromTrashClickHandler}
			/>
		);
	}

	componentDidMount() {
		this.props.unselectAll();
		this.props.listTrash({
			trashPageContext: this.props.match.params.trashPageContext,
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.match.params.trashPageContext !==
			this.props.match.params.trashPageContext
		) {
			setTimeout(() => {
				this.props.listTrash({
					trashPageContext: this.props.match.params.trashPageContext,
				});
				this.props.unselectAll();
				//scroll the document list to the top
				let tableBodyElement = document.querySelector(".rt-tbody");
				if (tableBodyElement) {
					tableBodyElement.scrollTop = 0;
				}
			}, 0);
		}
	}
	getUrlPrefix() {
		return "/trash/" + this.props.match.params.trashPageContext + "/";
	}
	getAPIBasepath() {
		return (
			this.props.match.params.trashPageContext +
			"/" +
			(decodeFullpath(this.props.match.params.fullpath) || "")
		);
	}
	switchedTab(value) {
		const newURL = "/trash/" + this.state.lastLocation[tabMap[value].url];
		this.props.history.push(newURL);
	}
	static getDerivedStateFromProps(props, state) {
		var lastLocation = { ...state.lastLocation };
		lastLocation[props.match.params.root] = encodeFullpath(
			props.match.params.root + "/" + (props.match.params.fullpath || "")
		);
		return { ...state, lastLocation };
	}
	render() {
		return (
			<div className="fullHeightFlex noDefaultMargin">
				<MaterialTabs
					style={{ height: "48px" }}
					activeTab={
						tabUrlMap[
							this.props.match.params.trashPageContext + "/"
						].index
					}
					tabs={tabMap}
					switchedTab={this.switchedTab}
				/>
				{this.props.match.params.trashPageContext !== "activity" ? (
					<TrashBinList
						loading={this.props.trashLoading}
						trashList={this.props.trashList}
						dataIsStale={this.props.trashListStale}
						style={{ flex: 1 }}
						urlPrefix={this.getUrlPrefix()}
						matterID={0}
						basepath={"/trash/"}
						breadcrumbRootName={
							basepathnameMap[
								this.props.match.params.trashPageContext
							]
						}
						// trashListHeader={}
						foldersOnTop={this.props.foldersOnTop}
						root={this.props.match.params.trashPageContext + "/"}
						apiBasepath={this.getAPIBasepath()}
						fullpath={this.props.match.params.fullpath}
						values={this.props.documentList}
						tabUrlMap={tabUrlMap}
						trashPageContext={
							this.props.match.params.trashPageContext + "/"
						}
					/>
				) : null}
				{this.props.match.params.trashPageContext === "activity" ? (
					<CustomizableTable
						tableUniqueID="/trash/activity"
						columns={this.jobsColumnConfig}
						data={this.props.trashList}
						className="fullWidth"
						autoResize
						loading={this.props.trashLoading}
						apiBasepath="/trash/activity"
						urlPrefix="/trash/activity/"
						dataIsStale={this.props.trashListStale}
						noResultsText="No Activity in the Trash Bin"
						defaultTabFilterValue={""}
						actionButtons={({ openCsvExport }) => (
							<DropDownButton
								title="Actions"
								pullRight
								iconComponent={<LexWorkplaceGavelIcon />}
								menuItems={[
									{
										text: "Export Data as CSV",
										onSelect: openCsvExport,
									},
								]}
							/>
						)}
						csvExport={{
							csvColumnRenderers: {
								startTime: (val) =>
									val ? new Date(val).toLocaleString() : "",
								endTime: (val) =>
									val ? new Date(val).toLocaleString() : "",
							},
							fileName: "trash-activity",
						}}
						leftSideFilterSpace={
							<div
								style={{
									display: "flex",
									marginTop: 10,
									marginRight: 12,
									marginBottom: 10,
									marginLeft: 12,
									alignItems: "center",
									maxWidth: "40rem",
								}}
							>
								<div>Permanent Delete Operations</div>
								<span
									title={
										"You can view the details of any permanent delete operation by clicking on the 'View Details' link in the Details column."
									}
								>
									<IconInfoCircle
										size={16}
										style={{
											marginLeft: 8,
											verticalAlign: "text-top",
										}}
									/>
								</span>
							</div>
						}
					/>
				) : null}
			</div>
		);
	}
}
TrashBinContainer.propTypes = {
	trashLoading: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
	trashLoading: state.trash?.loading,
	trashList: state.trash?.trashList,
	trashListStale: state.trash?.listStale,
	foldersOnTop: state.userSettings.foldersOnTop,
	documentListShowTrash: state.browserLocalstorage.documentListShowTrash,
});
export default connect(mapStateToProps, {
	unselectAll,
	setDocumentListShowTrash,
	listTrash,
	restoreFromTrashPageDocuments,
	restoreFromTrashPageEmails,
	restoreFromTrashPageNotes,
	restoreFromTrashPageFolders,
	deleteRestoreMultipleMattersFromTrashPage,
	setClientLifecycleStatus,
	generatePermanentDeleteManifestForDocuments,
	generatePermanentDeleteManifestForEmails,
	generatePermanentDeleteManifestForNotes,
	generatePermanentDeleteManifestForFolders,
	generatePermanentDeleteManifestForMatters,
	generatePermanentDeleteManifestForClients,
	getPermanentDeleteJobDetails,
})(TrashBinContainer);
